const isPageLink = (link) => link?.url?.startsWith?.("/");
export {
  isPageLink
};
//# sourceMappingURL=is-page-link.js.map
